<template>
  <div
    class="collapse-content_container"
  >
    <LvText v-if="field.title" h5 bold>
      {{ $t(`相關${field.title}`) }}
    </LvText>
    <DotLoading v-if="isLoading.content && !dataList.data.length" />
    <div v-if="dataList.data.length" class="cards-list_container">
      <div
        v-if="field.scopeReadable"
        class="cards-list_cards"
      >
        <slot :dataList="dataList.data">
          <component
            :is="field.component"
            v-for="(data,index) in dataList.data"
            :key="index"
            :to="$_to(data)"
            :title="data.title"
            :tags="data.tags"
            :spec="data.spec"
            :chips="data.chips"
            :card-content="data"
            :isloading="isLoading.content"
            :factoryTags="data.factoryTags"
            :is-ellipsis2="false"
            :has-btn="false"
            @click="$emit('click', data)"
          >
            <template v-slot:header>
              <slot name="header" :data="data"/>
            </template>
          </component>
        </slot>
      </div>
      <LvText v-else h4>{{ $t('無權限') }}</LvText>
    </div>
    <DotLoading v-if="isLoading.content && dataList.data.length" />
    <div
      v-if="!isLoading.content && dataList.page < dataList.lastPage"
      class="cards-list_buttons"
    >
      <WsButton001
        out-line
        medium-button
        @click="$_onLoadMoreData()"
      >
        {{ $t('載入更多') }}
      </WsButton001>
    </div>
  </div>
</template>
<script>
import base from "@/__vue2stone/service/wasaapi/v1/__base";

export default {
  name: "CollapseCards",
  props: {
    field: {
      type: Object,
      default: function () {
        return {};
      },
    },
    id: {
      type: String,
    },
    parentModelName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: {
        content: false,
      },
      dataList: {
        data: [],
        page: 1,
        lastPage: null,
      },
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
  },
  watch: {
    "dataList.page": function () {
      this.$_getDataList(this.dataList.page);
    },
  },
  mounted() {
    this.$_getDataList(1);
  },
  methods: {
    async $_getDataList(page) {
      if (!this.field.scopeReadable) return;
      this.isLoading.content = true;
      const currentFactoryId = this.$store.state.app.factoryId;
      const params = {
        factory: currentFactoryId,
        [`${this.parentModelName}`]: this.id,
        page,
      };
      let fetchObj = {
        params,
        pagination: true,
      };
      if (this.field.fetchUrl) fetchObj = {
        ...fetchObj,
        url: this.field.fetchUrl,
      };
      else fetchObj = {
        ...fetchObj,
        parentName: "factory",
        parentId: currentFactoryId,
        modelName: this.field.modelName,
      };
      try {
        const res = await base.index(fetchObj);
        this.dataList.lastPage = res.meta.last_page;
        const result = this.field.customFunction(res.data);
        this.dataList.data.push(...result);
      } catch (error) {
        alert(error);
      } finally {
        this.isLoading.content = false;
      }
    },
    $_onLoadMoreData() {
      this.dataList.page += 1;
    },
    $_to(data) {
      let url = data.customLinkPath
        ? `${this.field.to}/${data.customLinkPath}/${data.id}`
        : this.field.customPath
        ? this.field.customPath(data)
        : this.field.to
        ? `${this.field.to}/${data.id}`
        : '';
      if (this.field.query) url += `?${this.field.query(data)}`;
      if (this.field.redirect) url += `${this.field.query ? '&' : '?'}redirect=${this.field.redirect}`;
      return url;
    },
  },
};
</script>